export default __webpack_public_path__ + "static/media/SFProDisplay-Semibold.3926eb65.woff2";